import { isMobileDevice } from 'src/components/WidgetMaker/WidgetDnD/isMobileDevice';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { getSvg } from './utils';
import { openWhatsAppLeadModal } from 'src/utils/getWhatsAppRedirectionUrl';
import { useEffect, useState } from 'react';

function WhatsappFloatingIcon(props) {
  const {
    widgetContextState: { widgets, isBuilder },
  } = useWidgetDndContextData();
  const [isFooterComp, setIsFooterComp] = useState(false);
  const isMobile = isMobileDevice();
  const {
    widgetContextState: { activeFooterData },
  } = useWidgetDndContextData();
  const isGoToTopEnable = activeFooterData?.footerPropsConfig?.footerConfig?.showGoToTop;

  const activeWidget = widgets?.[(props as any).id];
  const activeWidgetProps = activeWidget?.props;

  const widgetOptions = {
    ...props.widgetOptions,
    ...activeWidgetProps,
  };

  // We have go to top icon in footer using intersection observer here when footer enter in viewport we slightly up the floating icon to prevent overlap
  useEffect(() => {
    // We have multiple wrappers in builder on top of footer tag for smooth interaction uses top wrapper id for intersection
    const footer = isBuilder
      ? document.getElementById('widget-Footer')
      : document.getElementById('footer');
    let observer;
    if (footer && isGoToTopEnable) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsFooterComp(true);
            } else {
              setIsFooterComp(false);
            }
          });
        },
        {
          root: null,
          threshold: 0.2,
        }
      );
    }
    observer?.observe(footer);
    return () => {
      if (footer) {
        observer?.unobserve(footer);
      }
    };
  }, [isGoToTopEnable]);

  const { isVisible, iconType, background } = widgetOptions;

  function handleIconClick() {
    openWhatsAppLeadModal();
  }

  return isVisible ? (
    <div
      onClick={handleIconClick}
      style={{
        background: iconType === 'type1' ? background : 'white',
        boxShadow: `0px 2px 6px 0px #111C3629`,
      }}
      className={`tw-fixed ${isBuilder ? (isFooterComp ? 'tw-bottom-[180px]' : 'tw-bottom-[48px]') : isFooterComp ? (isMobile ? 'tw-bottom-[84px]' : 'tw-bottom-[150px]') : 'tw-bottom-[24px]'}
      ${isMobile ? 'tw-right-[20px]' : isBuilder ? 'tw-right-[52px]' : 'tw-right-[40px]'}
      tw-z-100  tw-z-[100] tw-flex tw-h-[48px] tw-w-[48px] tw-cursor-pointer tw-flex-col tw-items-center tw-justify-center tw-rounded-[50%]`}
    >
      {getSvg(iconType)}
    </div>
  ) : null;
}

export default WhatsappFloatingIcon;
